"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "userBackground", {
  enumerable: true,
  get: function get() {
    return _userBackground["default"];
  }
});
var _userBackground = _interopRequireDefault(require("./userBackground"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }